import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown, faChevronUp, faSortUp, faSortDown, faFlask,faX, faPaperclip, faPlus, faPen, 
  faMobileAndroidAlt, faSave, faTimes,
  faEdit,faCoins  
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../Css/Tooltip.css';
import { Loader, Spinner } from '../../Loader/Loader';
import RewardRulesEngine from './rulesEngine'
import { decryptData } from '../../../utils/storageCrypto';

// Custom Select Components (minimal version from rules engine UI style - FIXED for fixed width/no wrap)
const Select = ({ children, value, onValueChange, placeholder = "Select option" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelect = (newValue) => {
    setSelectedValue(newValue);
    if (onValueChange) onValueChange(newValue);
    setIsOpen(false);
  };

  return (
    <div className="relative min-w-[200px]">  {/* FIXED: Fixed min-width to fit longest text */}
      <SelectTrigger onClick={() => setIsOpen(!isOpen)} value={selectedValue} placeholder={placeholder} />
      {isOpen && (
        <SelectContent>
          {React.Children.map(children, (child, index) => {
            if (child && child.type === SelectItem) {
              return React.cloneElement(child, { 
                key: child.key || index,
                onSelect: handleSelect,
                isSelected: child.props.value === selectedValue
              });
            }
            return child;
          })}
        </SelectContent>
      )}
    </div>
  );
};

const SelectTrigger = ({ children, onClick, value, placeholder }) => {
  const displayValue = value ? 
    React.Children.toArray(children).find(child => child.props.value === value)?.props.children || value 
    : placeholder;

  return (
    <button
      type="button"
      className="w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md focus:bg-white focus:ring-2 focus:ring-[#f7525a]/20 focus:outline-none transition-all duration-200 flex items-center justify-between hover:bg-gray-100"
      onClick={onClick}
    >
      <span className={`${value ? "text-gray-900" : "text-gray-400"} whitespace-nowrap overflow-hidden text-ellipsis`}>  {/* FIXED: No wrap, ellipsis if too long */}
        {displayValue}
      </span>
      <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-xs ml-2 flex-shrink-0" />  {/* FIXED: Prevent icon shrink */}
    </button>
  );
};

const SelectContent = ({ children }) => (
  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto min-w-[200px]">  {/* FIXED: Match min-width */}
    <div className="py-1">{children}</div>
  </div>
);

const SelectItem = ({ children, value, onSelect, isSelected }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onSelect) onSelect(value);
  };

  return (
    <button
      type="button"
      className={`w-full px-3 py-2 text-sm text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none transition-colors whitespace-nowrap ${
        isSelected 
          ? 'bg-gray-100 text-[#f7525a] font-medium'  // FIXED: Red text only, subtle bg highlight, bold for emphasis
          : 'text-gray-900'
      }`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

const RewardRulesList = () => {
  const navigate = useNavigate();
  const [rewardRules,setRewardRules] = useState([]);
  const [selectedRule, setSelectedRule] = useState(null);
  const [ruleId, setRuleId] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  console.log(backendApiUrl);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [mappedRules,setMappedRules] = useState([]);
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [showComponent, setShowComponent] = useState('none'); // 'none', 'edit', 'create'
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('all');
useEffect(() => {
    fetchRewardRules();
}, []);

const fetchRewardRules = async (attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
      const encryptedhubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedhubId);    
      const response = await fetch(fetchUrl + "rules/get-all-rules?hubId=" + hubId, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      
      console.log(data?.data)
      if (data?.data) {
      setRewardRules(data?.data);  
      setMappedRules(data?.data);

      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchRewardRules(attempt + 1), 1000); // Retry after 1 second
      } else {
       
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchRewardRules(attempt)); // Set retry function
      }
    }finally {
      setIsLoading(false);
    }
  };

  const handleRuleClick = (rule) => {
  if (ruleId === rule._id) {
    // If clicked rule is already selected, unselect it
    setRuleId(null);
    setSelectedRule(null);
    setShowComponent('none');
  } else {
    // Otherwise, select the rule
    setRuleId(rule._id);
    setSelectedRule(rule);
    setShowComponent('none'); // Only selection; edit happens explicitly
  }
};

    const handleCreateRule = () => {
  setShowCreatePopup(true);
};

// New: Handle type selection from popup
const handleSelectType = (selectedType) => {
  // Initialize a new rule structure
  const rule = { empty: true };
  const updatedRule = { ...rule, type: selectedType };
  setSelectedRule(updatedRule);
  setRuleId(null);
  setShowComponent('create'); // Show RuleBuilder component
  setShowCreatePopup(false); // Close popup
};
// New: Close create popup without action
const handleCloseCreatePopup = () => {
  setShowCreatePopup(false);
};

/*   const handleCreateRule = () => {
    // Initialize a new rule structure
    const rule = {empty:true};
        const updatedRule = { ...rule, type: "redeem" };

     setSelectedRule(updatedRule); // Clear selected rule
     setRuleId(null);
    setShowComponent('create'); // Show RuleBuilder component
  }; */

  const handleEditRule = () => {
    setShowComponent('edit');
  }

  const handleOpenSimulator = () => {
    navigate('/admin/app/rewardrules/rewardrulesimulator',{
      state: {
        Rule: [selectedRule] || [],
      },
    });
  };


  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex flex-row w-full h-full overflow-hidden">
      {/* List of rules Div start */}
      <div className="flex flex-col w-[24%] h-full border-r overflow-hidden">
        <div className="p-2 border-b flex flex-row justify-between flex-shrink-0">
        <Select 
          value={selectedFilter}
          onValueChange={(value) => setSelectedFilter(value)}
          placeholder="Select filter"
        >
          <SelectItem value="all">All Buildcoins Rules</SelectItem>
          <SelectItem value="reward">Reward Rules</SelectItem>
          <SelectItem value="redeem">Redeem Rules</SelectItem>
        </Select>

          <div className='flex gap-4'>
{/*             <button
              onClick={handleOpenSimulator}
              disabled={!selectedRule}
              className={`py-1 px-2 rounded-md transition-colors ${
                selectedRule
                  ? 'bg-[#f7525a] text-white hover:bg-green-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
              data-tooltip="Test Rule"
              title=""
              style={{ '--tooltip-bg': 'black' }}
            >
              <FontAwesomeIcon icon={faFlask} />
            </button> */}

            <button
              onClick={handleEditRule}
              disabled={!selectedRule}
              className={`py-1 px-2 rounded-md transition-colors ${
                selectedRule
                  ? 'bg-[#f7525a] text-white hover:bg-green-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
              data-tooltip="Edit Rule"
              title=""
              style={{ '--tooltip-bg': 'black' }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>

            <button
              className="mr-2 bg-[#f7525a] py-1 px-2 text-white rounded-md hover:bg-green-700 transition-colors"
              data-tooltip="Create Rule"
              title=""
              style={{ '--tooltip-bg': 'black' }}
              onClick={handleCreateRule}
            >
              <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
            </button>
          </div>
        </div>
        
{/* Rules List - Independent Scrolling */}
<div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
  <div className='flex flex-col'>
    {/* Filter rules based on selectedFilter */}
    {(() => {
      let filteredRules = mappedRules;
      if (selectedFilter === 'reward') {
        filteredRules = mappedRules.filter(rule => rule.type === 'reward');
      } else if (selectedFilter === 'redeem') {
        filteredRules = mappedRules.filter(rule => rule.type === 'redeem');
      }
      // For 'all', show all (no filter)

      if (filteredRules.length === 0) {
        return (
          <div className="p-4 text-center text-gray-500 text-sm">
          {selectedFilter === "all"
            ? "No rules found."
            : `No ${selectedFilter} rules found.`}
          </div>
        );
      }

      return filteredRules.map((rule) => (
        <div 
          key={rule._id} 
          onClick={() => handleRuleClick(rule)} 
          className={`border-b text-sm flex items-center px-4 py-2 ${ruleId === rule._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='flex flex-row'>
            <div>
              <input 
                type="checkbox" 
                className="mr-2 border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded" 
                checked={ruleId === rule._id} 
                readOnly
              />
            </div>
            <div className='flex flex-col'>
              <p className='text-sm font-semibold'>{rule?.criteria[0]?.name || 'Unnamed Criteria'}</p>
              <p className="text-gray-600 text-sm">{rule?.rules[0]?.name || 'Unnamed Rule'}</p>
              <p className={`text-xs ${rule?.type === 'reward' ? 'text-green-500' : 'text-red-500'}`}>
                {rule?.type === 'reward' ? 'Reward' : 'Redeem'}
              </p>
            </div>
          </div>
        </div>
      ));
    })()}
  </div>
</div>
      </div>
      {/* List of rules Div end */}

{/* Rule Builder/Editor Section - Independent Scrolling */}
<div className="flex-1 h-full border-l flex flex-col overflow-hidden">
  {showComponent === 'create' && selectedRule && (
    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <RewardRulesEngine 
        mode="create" 
        type={selectedRule.type}  // Pass the selected type
      />
    </div>
  )}
  {showComponent === 'edit' && selectedRule && (
    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <RewardRulesEngine 
        mode="edit" 
        existingRuleData={selectedRule}
        ruleId={ruleId}
        criteriaId={selectedRule.criteria?._id}  // Added optional chaining for safety
        type={selectedRule.type}
      />
    </div>
  )}
  {showComponent === 'none' && (
    <div className="flex justify-center items-center h-full bg-gray-50">
      <div className="text-center">
        <div className="mb-4">
          <FontAwesomeIcon 
            icon={faPlus} 
            className="text-6xl text-gray-300 mb-4" 
          />
        </div>
        <p className="text-gray-500 text-lg mb-2">No rule selected</p>
        <p className="text-gray-400 text-sm">Select a rule to edit or create a new rule</p>
        <button
          onClick={handleCreateRule}
          className="mt-4 bg-[#f7525a] text-white px-2 py-1 rounded-md hover:bg-[#e6474f] transition-colors"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Create New Rule
        </button>
      </div>
    </div>
  )}
</div>

      {/* New: Create Rule Type Selection Popup */}
      {showCreatePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900">
                Create New Rule
              </h2>
              <button
                onClick={handleCloseCreatePopup}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <FontAwesomeIcon icon={faX} className="text-xl" />
              </button>
            </div>

            {/* Description */}
            <p className="text-gray-600 mb-6 text-sm">
              Select the type of rule you want to create:
            </p>

            {/* Buttons */}
            <div className="space-y-3">
              <button
                onClick={() => handleSelectType('reward')}
                className="w-full py-3 px-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-medium rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faCoins} className="mr-2 text-white" />
                Reward Rule
                <span className="ml-2 text-xs opacity-90">(Earn coins)</span>
              </button>

              <button
                onClick={() => handleSelectType('redeem')}
                className="w-full py-3 px-4 bg-gradient-to-r from-orange-500 to-red-600 text-white font-medium rounded-lg hover:from-orange-600 hover:to-red-700 transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faCoins} className="mr-2 text-white" />
                Redeem Rule
                <span className="ml-2 text-xs opacity-90">(Spend coins)</span>
              </button>
            </div>

            {/* Footer */}
            <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end">
              <button
                onClick={handleCloseCreatePopup}
                className="text-gray-500 hover:text-gray-700 text-sm transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
  
export default RewardRulesList;
